import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pagination-buttons',
  templateUrl: './pagination-buttons.component.html',
  styleUrls: ['./pagination-buttons.component.scss']
})
export class PaginationButtonsComponent implements OnInit, OnChanges {

  constructor() { }

  @Input() public lengthAmount: number = 0;
  @Output() public position = new EventEmitter<number>()
  public numbers: number[] = [];
  public selectedNumber: number = 1;

  ngOnInit() {
    // console.log(Math.ceil(this.lengthAmount / 10))
    this.numbers = []
    for (let i = 0; i < Math.ceil(this.lengthAmount / 10); i++) {
      this.numbers.push(i + 1)
    }
  }

  ngOnChanges() {
    this.numbers = []
    for (let i = 0; i < Math.ceil(this.lengthAmount / 10); i++) {
      this.numbers.push(i + 1)
    }
    this.selectedNumber = this.numbers.length > 0 ? (
      this.selectedNumber > this.numbers[this.numbers.length - 1] ? 
      this.numbers[this.numbers.length - 1] : this.selectedNumber
    ) : 1
    this.position.emit(this.selectedNumber)
  }

  public next(){
    if (this.numbers.length > 0) {
      if (this.numbers[this.numbers.length - 1] > this.selectedNumber) {
        this.selectedNumber++
      }
    }
    this.position.emit(this.selectedNumber)
  }

  public previous(){
    if (this.numbers.length > 0) {
      if (this.selectedNumber > this.numbers[0]) {
        this.selectedNumber--
      }
    }
    this.position.emit(this.selectedNumber)
  }

  public changeNumber(n: number){
    this.selectedNumber = n;
  }

}
